import { QRCodeSVG } from 'qrcode.react';
import { useState, type FormEvent } from 'react';
import * as authApi from '../api/auth';

export function TotpEnrollment({ step, onDone }: { step: authApi.AuthStep; onDone: () => void }) {
  const [setup, setSetup] = useState<{ secret: string; otpAuthUri: string } | null>(null);
  const [code, setCode] = useState('');
  const [recoveryCodes, setRecoveryCodes] = useState<string[] | null>(null);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const start = async () => {
    setLoading(true); setError('');
    try { setSetup(await authApi.setupTotp(step)); }
    catch (cause) { setError(cause instanceof Error ? cause.message : 'Не удалось настроить аутентификатор.'); }
    finally { setLoading(false); }
  };

  const enable = async (event: FormEvent) => {
    event.preventDefault(); setLoading(true); setError('');
    try { setRecoveryCodes((await authApi.enableTotp(step, code)).recoveryCodes); setSetup(null); }
    catch (cause) { setError(cause instanceof Error ? cause.message : 'Неверный код аутентификатора.'); }
    finally { setLoading(false); }
  };

  return <>
    <div className="login-heading"><h1>Настройка двухфакторной защиты</h1>
      <p>Для входа требуется приложение-аутентификатор. Telegram для входа не используется.</p></div>
    {!setup && !recoveryCodes && <button className="button button--primary button--large button--full" type="button" onClick={() => void start()} disabled={loading}>
      {loading ? 'Готовим…' : 'Настроить аутентификатор'}</button>}
    {setup && <form className="auth-form" onSubmit={(event) => void enable(event)}>
      <div className="totp-qr" aria-label="QR-код для приложения-аутентификатора"><QRCodeSVG value={setup.otpAuthUri} size={196} /></div>
      <p>Отсканируйте QR-код или введите ключ вручную: <strong className="mono">{setup.secret}</strong></p>
      <div className="field-group"><label htmlFor="enrollment-code">Код из приложения</label><div className="input-shell">
        <input id="enrollment-code" inputMode="numeric" autoComplete="one-time-code" maxLength={6} value={code}
          onChange={(event) => setCode(event.target.value.replace(/\D/g, ''))} required /></div></div>
      <button className="button button--primary button--large button--full" disabled={loading || code.length !== 6}>Подтвердить код</button>
    </form>}
    {recoveryCodes && <div className="auth-form"><h2>Коды восстановления</h2>
      <p>Сохраните эти коды в безопасном месте. Каждый код действует один раз. После закрытия они не показываются.</p>
      <ul className="security-list">{recoveryCodes.map((item) => <li className="mono" key={item}>{item}</li>)}</ul>
      <label className="login-remember"><input type="checkbox" checked={saved} onChange={(event) => setSaved(event.target.checked)} /> Я сохранил коды</label>
      <button className="button button--primary button--large button--full" type="button" disabled={!saved} onClick={onDone}>Перейти ко входу</button>
    </div>}
    {error && <div className="form-message form-message--error" role="alert">{error}</div>}
  </>;
}
